import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  FaCalendarAlt,
  FaClipboardList,
  FaChartBar,
  FaUsers,
  FaTasks,
  FaHome,
} from 'react-icons/fa';
import './MeetingBottomNav.css';

const navItems = [
  { to: '/meetings/workspace', label: 'Home', icon: FaHome },
  { to: '/meetings/book', label: 'Book Room', icon: FaCalendarAlt },
  { to: '/meetings/my-bookings', label: 'My Bookings', icon: FaClipboardList },
  { to: '/meetings/schedule', label: 'Schedule', icon: FaChartBar },
  { to: '/meetings/create-team', label: 'Create Your Team', icon: FaUsers },
  { to: '/meetings/status', label: 'Dashboard', icon: FaTasks },
];

const MeetingBottomNav = () => {
  const location = useLocation();
  const isMeetingRoute =
    location.pathname === '/meeting-home' ||
    location.pathname.startsWith('/meetings/');

  if (!isMeetingRoute) return null;

  return (
    <nav className="meeting-bottom-nav" aria-label="Meeting navigation">
      <div className="meeting-bottom-nav-inner">
        {navItems.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `meeting-bottom-nav-item${isActive ? ' active' : ''}`
            }
          >
            <Icon className="meeting-bottom-nav-icon" aria-hidden />
            <span className="meeting-bottom-nav-label">{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default MeetingBottomNav;
